import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../components/useReveal';
import { useLang } from '../context/LanguageContext';
import t from '../translations';
import './Services.css';

function getServices(tx) {
  return [
    {
      color: 'blue',
      iconPath: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
      title: tx.svc1_title,
      sub: tx.svc1_desc,
      desc: tx.svc1_desc,
      items: tx.svc1_items.map((item, i) => ({ title: item, desc: item })),
      note: tx.sp_note1,
    },
    {
      color: 'orange',
      iconPath: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z',
      title: tx.svc2_title,
      sub: tx.svc2_desc,
      desc: tx.svc2_desc,
      items: tx.svc2_items.map((item, i) => ({ title: item, desc: item })),
      note: tx.sp_note2,
    },
    {
      color: 'green',
      iconPath: 'M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 008 20C19 20 22 3 22 3c-1 2-8 2-8 2C9 9 8 16 8 16c-3-3-3-8.5-3-8.5S12 6 17 8z',
      title: tx.svc3_title,
      sub: tx.svc3_desc,
      desc: tx.svc3_desc,
      items: tx.svc3_items.map((item, i) => ({ title: item, desc: item })),
      note: tx.sp_note3,
    },
  ];
}

function ServiceBlock({ service, index }) {
  const ref = useReveal();
  return (
    <div className="service-block reveal" ref={ref} style={{ transitionDelay: `${index * 0.05}s` }}>
      <div className="service-block-label">
        <div className={`sb-icon sbi-${service.color}`}>
          <svg viewBox="0 0 24 24" width="34" height="34" fill="#fff"><path d={service.iconPath} /></svg>
        </div>
        <h2>{service.title}</h2>
        <p className="sub">{service.sub}</p>
      </div>
      <div className="service-block-content">
        <p>{service.desc}</p>
        <div className="sub-services">
          {service.items.map(item => (
            <div className="sub-service" key={item.title}>
              <h4><span className={`dot dot-${service.color}`} />{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="service-note">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="var(--orange)">
            <path d="M12 2L1 21h22L12 2zm0 3.5L20.5 19h-17L12 5.5zM11 10v4h2v-4h-2zm0 6v2h2v-2h-2z"/>
          </svg>
          <p><strong>{service.note.split('.')[0]}.</strong>{service.note.substring(service.note.indexOf('.') + 1)}</p>
        </div>
      </div>
    </div>
  );
}

export default function Services() {
  const { lang } = useLang();
  const tx = t[lang];
  const SERVICES = getServices(tx);

  return (
    <main>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-inner">
            <div className="breadcrumb">
              <Link to="/">{tx.home}</Link><span className="sep">›</span><span>{tx.services}</span>
            </div>
            <div className="eyebrow">{tx.sp_eyebrow}</div>
            <h1>{tx.sp_h1_1}<br />{tx.sp_h1_2} <span>{tx.sp_h1_highlight}</span></h1>
            <p>{tx.sp_p}</p>
          </div>
        </div>
        <div className="page-hero-diagonal" />
      </section>

      {/* Services list */}
      <section className="services-full">
        <div className="container">
          {SERVICES.map((s, i) => <ServiceBlock key={s.title} service={s} index={i} />)}
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="container">
          <div className="cta-banner-inner">
            <h2>
              <span>{tx.sp_cta_span}</span>
              {tx.sp_cta_h2}
            </h2>
            <Link to="/contact" className="btn-dark">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
              </svg>
              {tx.sp_cta_btn}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
